import React from "react";
import "./LoginTopBar.css";
import logo from "./../../assets/images/logo1.png";
import { Link } from "react-router-dom";

const LoginTopBar = () => {
  return (
    <div className="mainContainerLoginTopBr">
      <Link to="/">
        <img src={logo} className="logoImgTopBar" />
      </Link>
    </div>
  );
};

export default LoginTopBar;
